import { render, staticRenderFns } from "./lb.vue?vue&type=template&id=73f15262&scoped=true"
import script from "./lb.vue?vue&type=script&lang=js"
export * from "./lb.vue?vue&type=script&lang=js"
import style0 from "./lb.vue?vue&type=style&index=0&id=73f15262&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f15262",
  null
  
)

export default component.exports